export const cardColors = {
  bgColor: '#e3f2fd',
  color: '#0d47a1'
}

export const chartColors = [
  "#1f77b4",
  "#ff7f0e",
  "#2ca02c",
  "#d62728",
  "#9467bd"
]

export const lineChartGradientColors = [
  "#1976d2", // Primary Blue
  "#5eaee6", // Light Blue
  "#42a5f5", // Sky Blue
  "#64b5f6", // Soft Blue
  "#90caf9", // Very Light Blue
  "#bbdefb"  // Pale Blue
];


export const pipelineBgColors = [
  "#f1f8fe", // very light blue
  "#bbdefb", // light blue
  "#90caf9", // soft blue
  "#64b5f6", // medium-light blue
  "#42a5f5", // mid blue
  "#2196f3", // stronger blue (still background-friendly)
  "#1565c0", // new darker blue
];

export const pipelineTextColors = [
  "#0d47a1", // dark navy
  "#0d47a1", // dark navy
  "#0c418e", // deep blue
  "#083974", // very dark blue
  "#062f5c", // nearly navy
  "#ffffff", // white for the darkest background
  "#ffffff", // white for new darker background
];


// 🎨 Light pastel colors for each numeric column (customize freely)
// export const pastelColors = [
//   "#e3f2fd", // light blue
//   "#fce4ec", // light pink
//   "#e8f5e9", // light green
//   "#fff3e0", // light orange
//   "#ede7f6", // light purple
//   "#f3e5f5", // light lavender
//   "#f9fbe7", // light lime
//   "#e0f7fa", // light cyan
//   "#fbe9e7", // light coral
//   "#fffde7", // light yellow
//   "#e1f5fe", // light sky blue
//   "#f1f8e9", // light mint
//   "#ffe8e1", // light peach
//   "#e0fffb", // light turquoise
// ];

// export const contrastColors = [
//   "#0d47a1", // dark blue (contrast for light blue)
//   "#880e4f", // deep magenta (contrast for light pink)
//   "#1b5e20", // forest green (contrast for light green)
//   "#e65100", // deep orange (contrast for light orange)
//   "#311b92", // indigo (contrast for light purple)
//   "#6a1b9a", // dark violet (contrast for light lavender)
//   "#827717", // olive green (contrast for light lime)
//   "#006064", // teal (contrast for light cyan)
//   "#bf360c", // brick red (contrast for light coral)
//   "#f57f17", // golden yellow (contrast for light yellow)
//   "#01579b", // strong sky blue (contrast for light sky blue)
//   "#33691e", // dark mint/green (contrast for light mint)
//   "#4e342e", // deep brown (contrast for peach)
//   "#004d40", // deep aqua navy (contrast for turquoise)
// ];

// export const chartColors = ['#BBDEFB', '#C8E6C9', '#FFF9C4', '#FFE0B2', '#F8BBD0', '#D1C4E9', '#B2EBF2']